export default __webpack_public_path__ + "static/media/cooking.9e37e6e3.png";